import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { window } from '../../helpers/BrowserHelpers';

var _ref = new URL(window.location.origin),
    DEFAULT_APP_DOMAIN = _ref.hostname;

export default function processSliteUrl(url) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      organizationDomain = _ref2.organizationDomain,
      _ref2$appDomain = _ref2.appDomain,
      appDomain = _ref2$appDomain === void 0 ? DEFAULT_APP_DOMAIN : _ref2$appDomain;

  try {
    var urlObject = new URL(url);
    var sliteDomain = [organizationDomain, appDomain].filter(function (e) {
      return e;
    }).join('.');
    var isCurrentOrganizationUrl = sliteDomain === urlObject.hostname;

    if (!isCurrentOrganizationUrl) {
      return {};
    }

    var blockId = urlObject.hash.slice(1) || undefined;

    var _ref3 = urlObject.pathname.match( // eslint-disable-next-line no-useless-escape
    /(?:\/s\/note\/([^\/\s]+))|(?:\/notes\/([^\/\s]+))/) || [],
        _ref4 = _slicedToArray(_ref3, 3),
        publicShareToken = _ref4[1],
        noteId = _ref4[2];

    return {
      publicShareToken: publicShareToken,
      noteId: noteId,
      blockId: blockId
    };
  } catch (e) {
    // No need to do anything
    return {};
  }
}